import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductArea } from '@ridango/components/lib/purchase/purchase.model';
import { AreaMapService } from '@ridango/core/lib/services/area-map.service';

@Component({
    selector: 'gl-area-image',
    templateUrl: './area-image.component.html',
    styleUrls: ['./area-image.component.scss']
})
export class AreaImageComponent {
    @Input() set selectedArea(value: ProductArea | null) {
        this.selectedAreaValue = value;
        void this.updateImageSrc();
    }

    get selectedArea(): ProductArea | null {
        return this.selectedAreaValue;
    }

    @Output() imageClick = new EventEmitter<void>();
    imageSrc: string | null = null;

    private selectedAreaValue: ProductArea | null = null;

    constructor(private readonly areaMapService: AreaMapService) {}

    private async updateImageSrc(): Promise<void> {
        this.imageSrc = await this.areaMapService.resolveAreaMapImageSrc(this.selectedAreaValue?.id ?? null);
    }
}
